var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('app-card',{staticClass:"pa-6"},[_c('h5',{staticClass:"text-h5 mb-6"},[_vm._t("title",function(){return [_vm._v(_vm._s(_vm.title))]})],2),_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }